export const OFFICE_REQUEST = "OFFICE_REQUEST";
export const OFFICE_SUCCESS = "OFFICE_SUCCESS";
export const OFFICE_FAIL = "OFFICE_FAIL"